export enum FeatureType {
  SHOPPING_CENTER = 'SHOPPING_CENTER',
  STORE = 'STORE'
}
